module.exports = __webpack_public_path__ + "img/client-droga-vet.153586a5.jpg";